import React from 'react';

export default function MetasPage() {
  return (
    <div>
      Qualidade - Metas (placeholder).
    </div>
  );
}

